"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var babylonjs_1 = require("babylonjs");
var ColorHelper = require("color");
exports.parseColorRGBA = function (colorString) {
    if (colorString === "transparent") {
        return babylonjs_1.Color4.FromColor3(babylonjs_1.Color3.Black(), 0.0);
    }
    var colorHelper = ColorHelper(colorString);
    var color = colorHelper
        .rgb()
        .array()
        .map(function (val) { return val / 255.0; });
    return babylonjs_1.Color4.FromColor3(babylonjs_1.Color3.FromArray(color), colorHelper.alpha());
};
exports.parseColorRGBAtoVFColor = function (colorString) {
    if (colorString.includes('(') && !colorString.includes('rgba')) {
        colorString = "rgba" + colorString;
    }
    var colorHelper = ColorHelper(colorString);
    var color = colorHelper.rgb();
    return { r: color.red(), g: color.green(), b: color.blue(), a: color.alpha() };
};
exports.parseColorRGBAObjectToVFColor = function (color) {
    return { r: color.r * 255, g: color.g * 255, b: color.b * 255, a: color.a };
};
exports.parseColorRGB = function (colorString) {
    var colorHelper = ColorHelper(colorString);
    var color = colorHelper
        .rgb()
        .array()
        .map(function (val) { return val / 255.0; });
    return babylonjs_1.Color3.FromArray(color);
};
exports.darkenColorRGB = function (colorString, darkenFactor) {
    var color = ColorHelper(colorString)
        .desaturate(darkenFactor)
        .darken(darkenFactor)
        .rgb()
        .array()
        .map(function (val) { return val / 255.0; });
    return babylonjs_1.Color3.FromArray(color);
};
